import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=e85d5624&scoped=true&"
import script from "./Builder.vue?vue&type=script&lang=js&"
export * from "./Builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85d5624",
  null
  
)

export default component.exports